module.exports = __webpack_public_path__ + "img/APPID.c34f668c.png";